import ApiService from "@/core/services/api.service";

export const history = {
    list: (data = null) => {
        const searchParams = new URLSearchParams();
        let params = data?data: {};
        Object.keys(params).forEach(key => searchParams.append(key, params[key]));
        return  ApiService.get("audit-log/list?"+searchParams.toString());
    }
}